import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Check, Zap, ArrowRight } from 'lucide-react';

const integrations = [
  {
    name: 'Dentrix',
    description: 'Seamless migration from Dentrix into Asha PMS, including patient, scheduling, and billing data.',
    logo: 'https://framerusercontent.com/images/FK2PxMGUliSNEptVBpWhWGjhW4.png',
  },
  {
    name: 'Eaglesoft',
    description: 'Seamless migration from Eaglesoft into Asha PMS with guided mapping and go-live support.',
    logo: 'https://framerusercontent.com/images/JN5q8qzSCZ7K4LwF01UYdhkXhmI.png',
  },
  {
    name: 'Open Dental',
    description: 'Seamless migration from Open Dental into Asha PMS with data QA before launch.',
    logo: 'https://framerusercontent.com/images/rlsK5y9oz2tQ5YKXeUw3yHuCHmQ.png',
  },
  {
    name: 'Curve Dental',
    description: 'Seamless migration from Curve Dental into Asha PMS for a clean, cloud-based go-live.',
    logo: 'https://framerusercontent.com/images/4gWMpRVsQK9Ft5gBD0QXiHTlc.png',
  },
  {
    name: 'DentiMax',
    description: 'Seamless migration from DentiMax into Asha PMS with white-glove onboarding.',
    logo: 'https://framerusercontent.com/images/29bYpN5ZZIRLBUb7d3V3wqrnO3o.png',
  },
  {
    name: 'Carestack',
    description: 'Seamless migration from Carestack into Asha PMS with unified records and workflows.',
    logo: 'https://framerusercontent.com/images/mAqJXI1WqQKj2I8cnIV678ndB0.png',
  },
  {
    name: 'Denticon',
    description: 'Seamless migration from Denticon into Asha PMS across one or many locations.',
    logo: 'https://framerusercontent.com/images/FK2PxMGUliSNEptVBpWhWGjhW4.png',
  },
  {
    name: 'Practice-Web',
    description: 'Seamless migration from Practice-Web into Asha PMS with scheduling and billing continuity.',
    logo: 'https://framerusercontent.com/images/JN5q8qzSCZ7K4LwF01UYdhkXhmI.png',
  },
  {
    name: 'SoftDent',
    description: 'Seamless migration from SoftDent into Asha PMS with careful data validation.',
    logo: 'https://framerusercontent.com/images/rlsK5y9oz2tQ5YKXeUw3yHuCHmQ.png',
  },
];

const IntegrationsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section - Clean & Minimal like Salix */}
      <section className="pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-gray-900">
            Seamless PMS Migration
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            We migrate practices from the systems below onto Asha PMS with white-glove onboarding and data QA.
          </p>
        </div>
      </section>

      {/* Integration Cards Grid - Salix Style */}
      <section className="pb-24 px-6">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {integrations.map((integration, index) => (
              <div
                key={index}
                className="group bg-white border border-gray-200 rounded-2xl p-8 hover:border-gray-300 hover:shadow-lg transition-all duration-300 cursor-pointer"
              >
                <div className="w-20 h-20 bg-gray-100 rounded-xl flex items-center justify-center mb-5">
                  <img
                    src={integration.logo}
                    alt={integration.name}
                    className="w-12 h-12 object-contain"
                  />
                </div>
                
                <h3 className="text-xl font-bold mb-3 text-gray-900">{integration.name}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{integration.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - Salix Style */}
      <section className="py-32 px-6 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto max-w-4xl text-center">
          <div className="mb-6">
            <img 
              src="https://framerusercontent.com/images/KwbIK5pnSfuE09FmQXHtZn2fUEw.svg" 
              alt="Icon" 
              className="w-14 h-14 mx-auto mb-6"
            />
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Plan Your Migration to Asha
          </h2>
          <p className="text-lg md:text-xl text-gray-600 mb-10">
            Talk through timeline, data scope, and go-live support with our team.
          </p>
          <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 rounded-lg text-base font-semibold transition-all duration-300 hover:scale-105 shadow-lg inline-flex items-center gap-2">
            Plan Your Migration
            <ArrowRight className="w-5 h-5" />
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IntegrationsPage;
